import _ from 'lodash';
import mixin from 'privates/utils/mixin';
import Element from './Element';
import DisabledMixin from './mixins/DisabledMixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import FocusMixin from './mixins/FocusMixin';
import ClickableMixin from './mixins/ClickableMixin';
import ValueMixin from './mixins/ValueMixin';
import * as Utils from 'ui/Utils';
import {validate} from 'privates/validations/validation';
import * as members from 'privates/privateMembers';
import {runValidationsAfterChange} from 'privates/validationsService/validationsService';


/**
 * @class Switch
 * @summary Switches are used for a single binary choice.
 * @mixes $w.Element
 * @mixes $w.DisabledMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @tagname switch
 * @viewername wixui.ToggleSwitch
 */
class Switch extends Element {
    /**
     * @member checked
     * @label property
     * @syntax
     * get checked(): boolean
     * set checked(value: boolean): void
     * @summary Sets or gets whether a switch is on or off.
     * @description
     *  Setting the `checked` property to `true` toggles the switch to the on
     *  position. Setting it to `false` toggles the switch to the off position.
     *
     *  Getting the `checked` property returns whether the switch is on or off.
     * @type {external:Boolean}
     * @memberof $w.Switch
     * @instance
     */
    get checked () {
        return Utils.getData(this, 'checked') || false;
    }

    /**
     * @param {external:Boolean} checked
     * @ignore
     */
    set checked (checked) {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const compType = members._type.get(this).compType;

        if (!validate({
            compType,
            functionName: 'checked',
            dataToValidate: {checked},
            compName: this.id
        })) {
            return;
        }

        runValidationsAfterChange(RMI, compId, checked);
        if (_.isNil(checked)){
            checked = false;
        }
        Utils.setData(this, { checked });
    }

    toJSON() {
        const {id, type, global, rendered, value, checked} = this;
        return {id, type, global, rendered, value, checked};
    }
}

mixin(Switch.prototype, DisabledMixin.prototype);
mixin(Switch.prototype, HiddenCollapsedMixin.prototype);
mixin(Switch.prototype, FocusMixin.prototype);
mixin(Switch.prototype, ClickableMixin.prototype);
mixin(Switch.prototype, ValueMixin.prototype);

export default Switch;



// WEBPACK FOOTER //
// ./js/modules/ui/Switch.es6